import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth";
import Layout from "./Layout";
import Login from "./pages/Login";
import Analytics from "./pages/Analytics";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Settings from "./pages/Settings";
import SheetDetail from "./pages/SheetDetail";
import Users from "./pages/Users";

function Protected({ children, adminOnly = false, superAdminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="container">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  // The money-wide view is the owner's only; the server enforces it too.
  if (superAdminOnly && !(user.role === "admin" && user.is_superadmin)) {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <Protected>
              <Layout />
            </Protected>
          }
        >
          <Route index element={<Projects />} />
          <Route path="projects/:projectId" element={<ProjectDetail />} />
          <Route path="sheets/:sheetId" element={<SheetDetail />} />
          <Route
            path="users"
            element={
              <Protected adminOnly>
                <Users />
              </Protected>
            }
          />
          {/* Earnings was folded into Analytics; keep old links working. */}
          <Route path="earnings" element={<Navigate to="/analytics" replace />} />
          <Route
            path="analytics"
            element={
              <Protected superAdminOnly>
                <Analytics />
              </Protected>
            }
          />
          <Route
            path="settings"
            element={
              <Protected adminOnly>
                <Settings />
              </Protected>
            }
          />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
